import React, { useMemo } from "react";

import { DropdownMenuContent as DropdownMenuContentUI } from "../dropdown-menu";

import { DropdownMenuItem } from "./DropdownMenuItem";
import { Action } from "./types";

interface DropdownMenuContentProps<DataT> {
  menuItems: Action<DataT>[];
  item?: DataT;
  className?: string;
}

export const DropdownMenuContent = <DataT,>({
  menuItems,
  item,
  className,
}: DropdownMenuContentProps<DataT>) => {
  const groupedMenuItems = useMemo(() => {
    const hasGroup = menuItems.some(menuItem => menuItem.group);

    if (!hasGroup) {
      return [["", menuItems] as [string, Action<DataT>[]]];
    }

    return Object.entries(
      menuItems.reduce(
        (acc, menuItem) => {
          const { group } = menuItem;
          if (group) {
            acc[group] = acc[group] || [];
            acc[group].push(menuItem);
          } else {
            acc[""] = acc[""] || [];
            acc[""].push(menuItem);
          }
          return acc;
        },
        {} as Record<string, Action<DataT>[]>,
      ),
    );
  }, [menuItems]);

  return (
    <DropdownMenuContentUI
      className={`mr-2 w-[224px] p-2 transition-all duration-200 ${className}`}
    >
      {groupedMenuItems.map(([group, actions], index) => (
        <React.Fragment key={group || `group-${index}`}>
          {group && (
            <div className="my-2 text-sm font-medium text-gray-900 first:mt-0">{group}</div>
          )}
          <div>
            {actions.map(action => (
              <DropdownMenuItem key={action.id} action={action} item={item} />
            ))}
          </div>
        </React.Fragment>
      ))}
    </DropdownMenuContentUI>
  );
};
